import React from "react";

const ContactSupportSection = () => {
  return (
    <section
      className="section-padding"
      style={{
        paddingTop: "80px",
        paddingBottom: "80px",
        background: "#fe0606",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-12">
            <div
              className="cta-box"
              style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "32px",
                boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
              }}
            >
              <div className="row align-items-center">
                <div className="col-lg-8 col-md-12">
                  <h2 style={{ marginBottom: "10px", color: "#111" }}>
                    Need Assistance?
                  </h2>
                  <p style={{ marginBottom: "18px", color: "#555" }}>
                    For any support related to travel, stay or event access:
                  </p>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "12px",
                        color: "#333",
                      }}
                    >
                      <i
                        className="fa fa-phone"
                        style={{ color: "#28a745", fontSize: "18px" }}
                      ></i>
                      <span style={{ fontSize: "16px" }}>
                        <strong>Call / WhatsApp:</strong>{" "}
                        <a
                          href="tel:+919289009709"
                          style={{
                            color: "#252686",
                            textDecoration: "none",
                            fontWeight: "600",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.textDecoration = "underline";
                            e.currentTarget.style.color = "#fe0606";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.textDecoration = "none";
                            e.currentTarget.style.color = "#252686";
                          }}
                        >
                          +91 9289009709
                        </a>
                      </span>
                    </li>
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "8px",
                        color: "#333",
                      }}
                    >
                      <i
                        className="fa fa-envelope"
                        style={{ color: "#28a745", fontSize: "18px" }}
                      ></i>
                      <span style={{ fontSize: "16px" }}>
                        <strong>Email:</strong>{" "}
                        <a
                          href="mailto:ea@jsa.net.in"
                          style={{
                            color: "#252686",
                            textDecoration: "none",
                            fontWeight: "600",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.textDecoration = "underline";
                            e.currentTarget.style.color = "#fe0606";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.textDecoration = "none";
                            e.currentTarget.style.color = "#252686";
                          }}
                        >
                          ea@jsa.net.in
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
                <div
                  className="col-lg-4 col-md-12"
                  style={{ textAlign: "right" }}
                >
                  <a
                    href="tel:+919289009709"
                    className="theme-btn"
                    style={{
                      display: "inline-block",
                      backgroundColor: "#252686",
                      color: "#fff",
                      padding: "14px 28px",
                      borderRadius: "8px",
                      fontWeight: 700,
                      textDecoration: "none",
                      transition: "background-color 0.2s ease-in-out",
                      marginBottom: "10px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#1a1a5e";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#252686";
                    }}
                  >
                    <i
                      className="fa fa-phone"
                      style={{ marginRight: "8px" }}
                    ></i>
                    Call Now
                  </a>
                  <p
                    style={{
                      marginTop: "10px",
                      color: "#999",
                      fontSize: "12px",
                    }}
                  >
                    24/7 Support Available
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSupportSection;
